import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=2a90c9b4&scoped=true&"
import script from "./Header.vue?vue&type=script&lang=js&"
export * from "./Header.vue?vue&type=script&lang=js&"
import style0 from "./style.scss?vue&type=style&index=0&id=2a90c9b4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a90c9b4",
  null
  
)

export default component.exports